const $buyForm = $(".questionsForm");
import "./validationAddMethods";
import applyDiscount from "../applyDiscount"; // Add the discount tag
import resetForm from "../resetForm";
import { buyValidationOptions } from "./buyValidationOptions";
import { payValidationOptions } from "./payValidationOptions";
import {
  checkFormValidOnInputChange,
  disableSubmitButton,
  enableOrDisableSubmitButton,
  enableSubmitButton,
} from "./enableOrDisableSubmitButton";
import "./checkEmail";

if ($buyForm.length > 0) {
  $buyForm.validate(buyValidationOptions);
  // Listen for change, etc on input
  checkFormValidOnInputChange($buyForm);
  // Page load
  $(document).ready(function () {
    enableOrDisableSubmitButton($buyForm);
  });
}

$("#dobHidden").rules("add", {
  over18: true,
  required: true,
});

// Validation rules based on input id - these inputs do not have unique names
$("#postcodeUK").rules("add", {
  postcodeUK: true,
  required: true,
});

// DE postcode
$("#postcodeDE").rules("add", {
  postcodeDE: true,
  required: true,
});

// AT postcode
$("#postcodeAT").rules("add", {
  postcodeAT: true,
  required: true,
});

// UK phone
$("#phoneUK").rules("add", {
  phoneWithOptionalZeroPrefixUK: true,
  required: true,
});

// DEAT phone
$("#phoneDEAT").rules("add", {
  phoneWithOptionalZeroPrefixDEAT: true,
  required: true,
});

$(".currency").rules("add", {
  required: true,
  minimum: 100,
  maximum: 10000,
});

// Apply discount on page load
if ($("#questionsForm_bike-item-list").length > 0) {
  applyDiscount();
}

$('[for="other"]').on("click", function () {
  resetForm($questionsForm);
  disableSubmitButton();
});

$('[for="home"]').on("click", function () {
  // reset form to original fields
  document.querySelector(".questionsForm").reset();
  enableSubmitButton();
});

// PAY app
let $payForm = $(".paymentForm");
if ($payForm.length > 0) {
  $payForm.validate(payValidationOptions);
  // Listen for change, etc on input
  checkFormValidOnInputChange($payForm);
  // Page load
  $(document).ready(function () {
    enableOrDisableSubmitButton($payForm);
  });
}
